export const emailjsKey = "qixHOVaJETAVIhWuX"
export const emailTemplateId = "template_9vcz1qd"
export const emailServiceId = "service_e7b7e3o"